module.exports = __webpack_public_path__ + "static/media/3.193ec810.jpg";